export const OFFERS_HERO_BLUR_DURATION = 1;

/** Cartes : 0,5 s après le début du blur-in du titre. */
export const OFFERS_CARD_ENTRANCE_DELAY = 0.5;
